<!--
Author: TangChen
Date: 2018-09-17
Desc: 我的资产组件，由index.js 配置引入
-->
<template>
    <div>
        <div :class="'bizcomp-my-plan bizcomp ' + className">
            <div class="my-plan-head">
                <el-tabs v-model="activeName" v-on:tab-click="handleClick">
                    <el-tab-pane name="1">
                        <el-badge slot="label" class="investment-1">普通定投</el-badge>
                    </el-tab-pane>
                    <el-tab-pane
                        v-if="
                            $cache.getCompanyInfoParam('10301003') &&
                            $cache.getCompanyInfoParam('10301003').indexOf('A86') > -1
                        "
                        name="7"
                    >
                        <el-badge slot="label" class="investment-7">目标盈定投</el-badge>
                    </el-tab-pane>
                    <el-tab-pane
                        v-if="
                            $cache.getCompanyInfoParam('10301003') &&
                            $cache.getCompanyInfoParam('10301003').indexOf('A19') > -1
                        "
                        name="4"
                    >
                        <el-badge slot="label" class="investment-2">智能定投</el-badge>
                    </el-tab-pane>
                    <!-- <el-tab-pane name="a">
                        <el-badge slot="label" class="investment-3">组合定投</el-badge>
                    </el-tab-pane> -->
                </el-tabs>
                <!--                <div class="cal-content pointer" v-on:click="$router.push('/planCalculator')">-->
                <!--                    <img src="../../assets/img/cal-log.png" alt="" class="cal-log" />-->
                <!--                    定投计算器&gt;&gt;-->
                <!--                </div> -->
            </div>

            <div v-if="!addC" class="main-content-div">
                <div v-for="(item, index) of pageFund" :key="index" class="main-content">
                    <div class="left-content">
                        <div class="fund-name-code">
                            <div class="buy-plan-name">
                                {{ item.buyplanname }}
                            </div>
                            <span v-if="item.planflag != 'a'">
                                <span class="fund-name">
                                    {{ item.fundname }}
                                </span>
                                <span class="fund-code">
                                    {{ item.fundcode }}
                                </span>
                            </span>
                            <span v-else class="fund-name">
                                {{ item.portfolioname }}
                            </span>
                            <span
                                :class="
                                    'fund-status ' +
                                    (item.status == 'N'
                                        ? 'normal-color'
                                        : item.status == 'P'
                                        ? 'stop-color'
                                        : 'termination-color')
                                "
                            >
                                {{ formatterStatus(item.status) }}
                            </span>
                            <span v-if="$util.hasFM(item)" class="fm2">浮动管理费基金</span>
                        </div>
                        <div class="fund-info">
                            <div class="margin-100 width-100">
                                <div class="color-666">
                                    {{ activeName == "2" ? "基础金额" : "扣款金额" }}
                                </div>
                                <div>
                                    {{ formatterNum(item.firstinvestamount) }}
                                </div>
                            </div>
                            <div class="margin-100 width-180">
                                <div class="color-666">扣款账户</div>
                                <div v-if="item.channelid && item.bankcode && item.depositcard">
                                    {{
                                        $cache.getDict("110079", item.channelid.substr(0, 4)) +
                                        "-" +
                                        $cache.getDict("110080", item.bankcode).substr(-4, 4) +
                                        "（" +
                                        item.depositcard.substr(-4, 4) +
                                        "）"
                                    }}
                                </div>
                                <div v-else>--</div>
                            </div>
                            <div class="margin-100 width-150">
                                <div class="color-666">扣款时间</div>
                                <div>{{ formatterCycle(item) }}</div>
                            </div>
                            <div>
                                <div class="color-666">预计下次扣款时间</div>
                                <div>{{ $util.fmtDate(item.nextinvestdate) }}</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button class="desc-btn" v-on:click="showDetail(item.planno)">详情</button>
                    </div>
                </div>
                <div
                    class="add-plan-content"
                    v-on:click="activeName === 'a' ? (addC = true) : $router.push('/gfund/glist')"
                >
                    <div class="add-plan-btn">
                        <div class="add-icon">+</div>
                        <div class="add-text">新增定投协议</div>
                    </div>
                </div>
                <el-pagination
                    v-if="allPage - 0 >= Number(pageSize)"
                    :current-page.sync="curPage"
                    :page-size="Number(pageSize)"
                    layout="total, prev, pager, next"
                    :total="allPage"
                    class="pagination-content"
                    v-on:current-change="handleCurrentChange"
                ></el-pagination>
            </div>

            <!--组合定投start-->
            <combofund v-if="activeName === 'a' && addC"></combofund>
            <!--组合定投end-->
        </div>
        <footerQuestions
            v-if="$const.warmReminderDisplay"
            :common-question="commonQuestion"
        ></footerQuestions>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import combofund from "@/bizcomponents/comboBuy/combofund.vue";

export default {
    name: "MyPlanDc",
    components: { footerQuestions, combofund },
    mixins: [mixin],
    data() {
        return {
            activeName: "1",
            curPage: 1,
            allPage: 0,
            pageSize: this.$util.getConfig().const.PAGE_SIZE
                ? this.$util.getConfig().const.PAGE_SIZE
                : 10,
            gfund: [],
            detailFund: [],
            pageFund: [],
            commonQuestion: [],
            addC: false
        };
    },
    created() {
        this.commonQuestion = this.$const.commonQuestion.commonQuestion11;
        this.getPlanList();
        if (this.$route.query && this.$route.query.planType) {
            this.activeName = this.$route.query.planType;
        }
    },
    methods: {
        showDetail(id) {
            const fund = this.detailFund.filter((item) => {
                return item.planno === id;
            })[0];
            if (fund) {
                const _x = Object.assign({}, fund);
                sessionStorage.setItem("plandetail", JSON.stringify(_x));
                this.$router.push({
                    name: "plandetail",
                    query: { fundcode: _x.fundcode, planType: this.activeName }
                });
            }
        },
        handleClick(tab, event) {
            this.addC = false;
            this.detailFund = [];
            this.gfund.forEach((item) => {
                if (item.planflag == this.activeName) {
                    this.detailFund.push(item);
                }
            });
            this.curPage = 1;
            this.handleCurrentChange();
        },
        formatterCycle(row) {
            if (!row.investcycle || !row.investcyclevalue) {
                return "";
            }
            const cyclestr =
                (row.investcycle == "2" ? "每" : "") +
                this.$cache.getDict("110009", row.investcycle); // 0-每月，1-每周，2-双周，3-每日
            let valuestr;
            if (row.investcycle == "0") {
                valuestr = row.investcyclevalue + "日";
            } else if (row.investcycle == "3") {
                valuestr = "";
            } else {
                valuestr = "星期" + this.$util.numsDayToText(row.investcyclevalue);
            }
            return cyclestr + (this.$util.isEmpty(valuestr) ? "" : valuestr);
        },
        formatterStatus(value) {
            if (value == "N") {
                return "正常";
            } else if (value == "P") {
                return "暂停";
            } else {
                return "终止";
            }
        },
        formatterNum(value) {
            if (value.indexOf(",") > -1) {
                const _x = value.split(",");
                let _z = "";
                // 定转显示
                for (let i in _x) {
                    _z += this.$util.fmtNum(_x[i]) + "</br>";
                }
                return _z;
            }
            return this.$util.fmtNum(value);
        },
        handleCurrentChange() {
            this.allPage = this.detailFund.length;
            let i = 0;
            this.pageFund = [];
            for (i; i < this.pageSize; i++) {
                if (this.detailFund[(this.curPage - 1) * this.pageSize + i]) {
                    this.pageFund.push(this.detailFund[(this.curPage - 1) * this.pageSize + i]);
                } else {
                    return;
                }
            }
        },
        // 获取资产信息
        async getPlanList() {
            const res = await fundApi.getPlan();
            if (res.data) {
                this.gfund = res.data.data || [];
                // 如果是组合定投，那么把组合里包含的几种基金数据由字符串转成数组
                this.gfund.map((item) => {
                    item.portfolioinfo = item.portfolioinfo ? JSON.parse(item.portfolioinfo) : "";
                    return item;
                });
                this.gfund = this.gfund.filter((item) => {
                    return item.status == "N" || item.status == "P";
                });
                this.gfund = this.planArrGroup(this.gfund);
                this.detailFund = this.gfund;
                this.handleClick();
            }
        },
        // 对定投协议进行排序，列表第一排列顺序为状态，参与中>已暂停>已终止；列表第二排列顺序为定投成功期数，以期数最多倒序排列；
        planArrGroup(planArr) {
            const successFund = [];
            const stopFund = [];
            const terminationFund = [];
            planArr.forEach((item) => {
                if (item.status == "N") {
                    successFund.push(item);
                } else if (item.status == "P") {
                    stopFund.push(item);
                } else {
                    terminationFund.push(item);
                }
            });
            return [
                ...this.planArrSort(successFund),
                ...this.planArrSort(stopFund),
                ...this.planArrSort(terminationFund)
            ];
        },
        planArrSort(planArr) {
            if (planArr.length == 0) {
                return [];
            }
            const planObject = {};
            planArr.forEach((item) => {
                let key = item.investcycle + "-" + item.investcyclevalue;
                if (!planObject[key]) {
                    // 如果该key不存在于结果对象中，则初始化一个新的数组
                    planObject[key] = [];
                    // 将当前项添加到对应的数组中
                    planObject[key].push(item);
                } else {
                    planObject[key].push(item);
                }
            });
            const planArrSort = [];
            Object.values(planObject).forEach((item) => {
                planArrSort.push(item);
            });
            planArrSort.sort((a, b) => b.length - a.length);
            return [].concat(...planArrSort);
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-my-plan {
    .my-plan-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid var(--color-divided);
        font-weight: normal;
        .investment-1:hover {
            color: var(--color-primary);
        }
        .investment-2:hover {
            color: var(--color-primary);
        }
        .investment-3:hover {
            color: var(--color-primary);
        }
        .investment-7:hover {
            color: var(--color-primary);
        }
        .cal-content {
            margin-right: 20px;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            color: var(--color-primary);
            display: flex;
            align-items: center;
            justify-content: center;
            width: 150px;
            border-radius: 20px;
            background: var(--color-bg-container);
            box-sizing: border-box;
            border: 1px solid var(--color-primary);
            .cal-log {
                margin-right: 4.6px;
            }
        }
    }
    :deep(.el-tabs__header) {
        margin: 0;
    }
    :deep(.el-tabs__nav-wrap::after) {
        height: 0 !important;
    }
    :deep(.el-tabs__item) {
        padding: 0;
        width: 130px;
        text-align: center;
        height: 70px;
        line-height: 70px;
        font-family: "Source Han Sans CN";
        font-size: 20px;
        color: var(--color-text-regular);
    }
    :deep(.is-active) {
        color: var(--color-primary);
        font-weight: 500;
    }
    :deep(.el-tabs__active-bar) {
        width: 80px !important;
        height: 4px;
        margin-left: 25px;
        background: var(--color-primary);
        position: absolute;
        top: 59px;
    }
    .main-content-div {
        padding: 20px;
        .add-plan-content {
            padding: 16px 0;
            border-bottom: 1px solid var(--color-divided);
            cursor: pointer;
            .add-plan-btn {
                width: 248px;
                height: 50px;
                border-radius: 30px;
                background: var(--color-bg-container);
                margin: 0 auto;
                display: flex;
                justify-content: center;
                align-items: center;
                .add-icon {
                    padding: 4px 8px;
                    background: var(--color-primary);
                    border: none;
                    border-radius: 50%;
                    color: var(--color-bg-container);
                    margin-right: 6px;
                }
                .add-text {
                    color: var(--color-primary);
                }
            }
            .add-plan-btn:hover {
                color: var(--color-bg-container);
                background-color: var(--color-primary);
                .add-icon {
                    border: 1px solid var(--color-border-base);
                }
                .add-text {
                    color: var(--color-bg-container);
                    background-color: var(--color-primary);
                }
            }
        }
    }
    .main-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        border-bottom: 1px solid var(--color-bg-divided);
        .left-content {
            padding: 20px 0 19px;
            .fund-name-code {
                padding-bottom: 14px;
                .buy-plan-name {
                    font-size: 18px;
                    font-weight: bold;
                    line-height: 20px;
                    padding-bottom: 5px;
                }
                .fund-name {
                    font-size: 16px;
                    color: var(--color-text-recent);
                    font-weight: bold;
                    line-height: 20px;
                    margin-right: 10px;
                }
                .fund-code {
                    font-size: 14px;
                    font-weight: 500;
                    margin-right: 10px;
                    color: var(--color-text-recent);
                }
                .fund-status {
                    padding: 3px 10px;
                    font-size: 12px;
                    font-weight: 500;
                    text-align: center;
                    border-radius: 15px;
                }
            }
            .fund-info {
                display: flex;
            }
        }
    }
    .el-pagination {
        margin: 19px 0 0;
    }
    .desc-btn {
        width: 107px;
        height: 40px;
        border-radius: 2px;
        color: var(--color-primary);
        background: var(--color-bg-container);
        box-sizing: border-box;
        border: 1px solid var(--color-divided);
        cursor: pointer;
    }
    .desc-btn:hover {
        color: var(--color-bg-container);
        background: var(--color-primary);
    }
    .pagination-content {
        text-align: end;
    }
    .color-666 {
        color: var(--color-text-regular);
    }
    .color-E60012 {
        color: var(--color-primary);
    }
    .normal-color {
        color: var(--color-primary);
        background: var(--color-bg-page);
    }
    .stop-color {
        color: var(--color-warning);
        background: var(--color-bg-page);
    }
    .termination-color {
        color: var(--color-danger);
        background: var(--color-bg-page);
    }
    .margin-100 {
        margin-right: 100px;
    }
    .width-100 {
        width: 100px;
    }
    .width-150 {
        width: 150px;
    }
    .width-180 {
        width: 180px;
    }
}
</style>
